export default __webpack_public_path__ + "static/media/EAST1060.34I-34185_-18432_0.a82c48d2.jpg";